var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit04SolidStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 20.75C11 20.1977 11.4477 19.75 12 19.75H18C18.5523 19.75 19 20.1977 19 20.75C19 21.3023 18.5523 21.75 18 21.75H12C11.4477 21.75 11 21.3023 11 20.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6517 2.76256C17.9682 2.07915 16.8602 2.07914 16.1768 2.76256L14.5 4.43933L19.5607 9.49999L21.2374 7.82323C21.9209 7.13981 21.9209 6.03177 21.2374 5.34835L18.6517 2.76256Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 10.5606L13.4394 5.49999L2.76259 16.1768C2.4344 16.505 2.25003 16.9501 2.25003 17.4142V21C2.25003 21.4142 2.58582 21.75 3.00003 21.75H6.58582C7.04995 21.75 7.49506 21.5656 7.82325 21.2374L18.5 10.5606Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit04SolidStandard);
export default __webpack_public_path__ + "static/media/edit-04-solid-standard.384572d1f17eb0c94758801746503092.svg";
export { ForwardRef as ReactComponent };